import styles from './index.css';

import * as ICONS from './svgs';

import * as React from 'react';
import {get} from 'lodash';
import classNames from 'classnames';

import {TStyles} from '../../Definitions';

type TIconProps = {
	name: string;
	className?: string;
	style?: TStyles;
	spin?: boolean;
	rotate?: boolean;
}
export default ({name, className, style = {}, spin, rotate}: TIconProps) => {
	const IconComponent = get(ICONS, name);

	return IconComponent
		? (
			<div
				style={style}
				className={classNames(
					styles.icon,
					className,
					spin && styles.spin,
					rotate && styles.rotating,
				)}
			>
				<IconComponent/>
			</div>
		)
		: null;
}
